<template>
  <div
    class="chip"
    :class="{
      'size-small': size === 'small' && !bold && !italic,
      'size-small-bold': size === 'small' && bold,
      'size-small-italic': size === 'small' && italic,
      'size-medium': size === 'medium',
      'size-medium-bold': size === 'medium' && bold,
      'size-medium-italic': size === 'medium' && italic,
      'background-light': background === 'light',
      'background-solid': background === 'solid',
      'background-transparent': background === 'transparent',
      'type-default': type === 'default',
      'type-primary': type === 'primary',
      'type-secondary': type === 'secondary',
      'type-light': type === 'light',
      'type-warning': type === 'warning',
      'type-error': type === 'error',
    }"
  >
    <div v-if="dot" class="chip__dot" />
    <SvgIcon
      v-if="iconLeft"
      :name="iconLeft"
      class="chip__icon"
    />
    <img
      v-else-if="iconUrl"
      :src="iconUrl"
      alt="icon"
      class="chip__icon"
    />
    <UiText
      :font="c_fontType"
      class="chip__text"
      :text="text"
    >
      <slot>
        {{ text }}
      </slot>
    </UiText>
    <SvgIcon
      v-if="iconRight"
      :name="iconRight"
      class="chip__icon"
    />
  </div>
</template>

<script>
const size = ['small', 'medium']
const background = ['light', 'solid', 'transparent']
const type = ['default', 'primary', 'secondary', 'light', 'warning', 'error']

export default {
  name: 'UiBadge',
  props: {
    dot: { type: Boolean, default: false },
    text: { type: [String, Number] },
    size: { type: String, default: 'small', validator: (v) => size.includes(v) },
    background: { type: String, default: 'solid', validator: (v) => background.includes(v) },
    type: { type: String, required: false, validator: (v) => type.includes(v) },
    bold: { type: Boolean },
    italic: { type: Boolean },
    iconLeft: { type: String },
    iconRight: { type: String },
    iconUrl: { type: String },
  },
  computed: {
    c_fontType() {
      if (this.size === 'small' && this.bold) return 'components-badge-small-bold'
      if (this.size === 'small' && this.italic) return 'components-badge-small-italic'
      if (this.size === 'medium' && this.bold) return 'components-badge-medium-bold'
      if (this.size === 'medium' && this.italic) return 'components-badge-medium-italic'
      if (this.size === 'medium') return 'components-badge-medium'
      return 'components-badge-small'
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
